module.exports = __webpack_public_path__ + "media/images/icons/group-8c6167061ec6c44f93745e36e218df5e.svg";